import { useMemo } from "react";

import { getFirstDayOfMonth } from "@/lib/dayjs/get-first-day-of-month";
import { getLastDayOfMonth } from "@/lib/dayjs/get-last-day-of-month";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

export const useYearAndMonthSelectBox = () => {
	const todaysDt = useMemo(() => getTodaysDate(), []);
	const { startDt, endDt } = useMemo(() => {
		return {
			startDt: getFirstDayOfMonth({ date: todaysDt }),
			endDt: getLastDayOfMonth({ date: todaysDt }),
		};
	}, [todaysDt]);

	return {
		todaysDt,
		startDt,
		endDt,
	};
};
